import qs from 'qs';
import { axiosApiInstance } from 'Store';
import { getNormalizedSaleModuleName } from 'utils/formatters/getNormalizedSaleModuleName';
import { AdvertisementAnalysis, SaleModule } from 'utils/types/AnalysisModels';
import { AnalysisSaleFilterReturnData } from 'utils/types/AnalysisSale';

import { activeNotification } from 'components/functions/activeNotification';

const getAnalysis = (module: SaleModule, filters: AnalysisSaleFilterReturnData): Promise<AdvertisementAnalysis> => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { locations, filterLocations, ...filtersWithoutLocations } = filters;

    const locationIds = Object.keys(filters.savedLocations).map((id) => {
        return { id: Number(id) };
    });

    return axiosApiInstance({
        method: 'POST',
        url: `/v2/analysis/sale/${getNormalizedSaleModuleName(module)}`,
        data: {
            ...filtersWithoutLocations,
            filterLocations: locationIds
        },
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' });
        }
    })
        .then((resp) => {
            if (resp.data) {
                return {
                    ...resp.data
                    // filters: filters as AnalysisFiltersType,
                    // city,
                };
            }

            activeNotification(
                'Nie znaleziono wyników',
                'Zmień wartości wyszukiwania',
                'warning'
            );

            return {
                noItems: true,
                areaAnalysisList: [],
                timeAnalysisList: [],
                trendResult: []
                // filters: filters as AnalysisFiltersType,
            };
        })
        .catch(() => {
            return {
                noItems: true,
                areaAnalysisList: [],
                timeAnalysisList: [],
                trendResult: []
                // filters: filters as AnalysisFiltersType,
            };
        });
};

export const analysisApiRequests = {
    getAnalysis
};
